import { render, staticRenderFns } from "./rejectDialog.vue?vue&type=template&id=d671322c&scoped=true"
import script from "./rejectDialog.vue?vue&type=script&lang=ts"
export * from "./rejectDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d671322c",
  null
  
)

export default component.exports